import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "./Chrome";

export const CONTACT = "contact@gamedaytime.com";
export const OPERATOR = "GamedayTime is a DBA of CampbellsLife LLC.";
const LINKS: [string, string][] = [["/privacy", "Privacy"], ["/terms", "Terms"], ["/sms", "SMS Guide"], ["/text", "Text Guide"], ["/help", "Help"]];

export function PublicFooter({ centered = false }: { centered?: boolean }) {
  return (
    <footer data-testid="public-footer" className={`relative mt-16 border-t border-white/10 px-6 py-8 text-xs text-zinc-400 sm:px-12 ${centered ? "text-center sm:text-left" : ""}`}>
      <div className={`mx-auto flex max-w-6xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between ${centered ? "items-center" : ""}`}>
        <nav className={`flex flex-wrap items-center gap-x-4 gap-y-2 ${centered ? "justify-center" : ""}`} aria-label="Legal">
          {LINKS.map(([to, l]) => <Link key={to} to={to} className="text-zinc-300 hover:text-signal" data-testid={`footer-link-${l.toLowerCase().replace(" ", "-")}`}>{l}</Link>)}
          <a href={`mailto:${CONTACT}`} className="text-zinc-300 hover:text-signal" data-testid="footer-contact">{CONTACT}</a>
        </nav>
        <p data-testid="footer-operator">{OPERATOR} © {new Date().getFullYear()} CampbellsLife LLC</p>
      </div>
    </footer>
  );
}

export function PublicHeader({ className = "", logo = true }: { className?: string; logo?: boolean }) {
  const item = "whitespace-nowrap hover:text-signal";
  return (
    <header className={`mx-auto flex max-w-6xl items-center gap-3 px-5 py-6 sm:px-12 ${logo ? "justify-between" : "justify-end"} ${className}`}>
      {logo && <BrandLogo to="/" size="md" />}
      <nav className="flex gap-3 text-xs text-zinc-300 sm:gap-4 sm:text-sm">
        <Link to="/text" className={item} data-testid="public-text-guide-link">Text Guide</Link>
        <Link to="/login" className={item} data-testid="public-crew-login">Welcome Crew</Link>
        <Link to="/admin/login" className={item} data-testid="public-admin-login">Manage Time</Link>
      </nav>
    </header>
  );
}

export function PublicPage({ title, eyebrow, subtitle, updated, testId, children }: { title: string; eyebrow: string; subtitle?: string; updated?: string; testId: string; children: ReactNode }) {
  return (
    <div data-testid={testId} className="min-h-screen">
      <PublicHeader />
      <main className="mx-auto max-w-3xl px-5 sm:px-6">
        <article className="glass-raised animate-rise rounded-[24px] p-6 sm:p-10">
          <p className="label-caps text-signal">{eyebrow}</p>
          <h1 className="mt-2 font-display text-4xl font-light text-white sm:text-5xl">{title}</h1>
          {subtitle && <p className="mt-2 text-lg text-zinc-200" data-testid="public-page-subtitle">{subtitle}</p>}
          <p className="mt-3 text-sm text-zinc-400">{OPERATOR}{updated ? ` · Last updated ${updated}` : ""}</p>
          <div className="prose-public mt-8 space-y-8 text-[15px] leading-relaxed text-zinc-200">{children}</div>
        </article>
      </main>
      <PublicFooter />
    </div>
  );
}

export function Section({ title, children, id }: { title: string; children: ReactNode; id?: string }) {
  return (
    <section id={id} className="space-y-3">
      <h2 className="text-xl font-medium tracking-[-0.01em] text-white">{title}</h2>
      {children}
    </section>
  );
}

export const UPDATED = "October 13, 2026";
